// extracted by mini-css-extract-plugin
module.exports = {"container":"Row_container__2gwsy","title":"Row_title__C_NSh","row":"Row_row__1VIqE","contain":"Row_contain__3lvKR","left":"Row_left__3UPs8","right":"Row_right__EYtYJ"};